export const meteringServiceChangeSchema = {
  title: 'Metering Service Change',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'string',
      title: 'MPAN Core',
    },
    metering_service_mpid: {
      type: 'string',
      title: 'Metering Service MPID',
    },
    effective_from: {
      type: 'string',
      format: 'date',
      title: 'Effective From',
    },
    contract_reference: {
      type: 'string',
      title: 'Contract Reference',
    },
    appointment_scenario: {
      type: 'string',
      title: 'Appointment Scenario',
      enum: ['COS', 'CSP', 'USP', 'SEG', 'MCA', 'MCS'],
      enumNames: [
        'COS – Change of Supplier',
        'CSP – Change of Supplier and Party',
        'USP – Unregistered Site Process',
        'SEG – Segment Exchange',
        'MCA – Metering Contract Appointment',
        'MCS – Metering Contract Switch',
      ],
    },
  },
  required: ['mpan_core', 'metering_service_mpid', 'effective_from', 'appointment_scenario'],
};

export const meteringServiceChangeUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
  },
  metering_service_mpid: {
    'ui:placeholder': 'Select Metering Service Provider',
  },
  effective_from: {
    'ui:widget': 'date',
    'ui:placeholder': 'Select effective date',
  },
  contract_reference: {
    'ui:placeholder': 'Optional contract reference',
  },
  appointment_scenario: {
    'ui:placeholder': 'Select appointment scenario',
  },
};
